import service from "../service";

export const getExceptionsService = (active) => (
  service('get', `v3/ruteo/excepciones/${active}`)
)

export const getExceptionHistoryService = (idException) => (
  service('get', `v3/ruteo/excepciones/${idException}/historial`)
)

export const getExceptionHistorTxnsService = (idException, idHistory) => (
  service('get', `v3/ruteo/excepciones/${idException}/historial/${idHistory}`)
)

export const createExceptionService = (data) => (
  service('post', `v3/ruteo/excepciones`, {
    data: { ...data }
  })
)

export const updateExceptionService = (idException, data) => (
  service('patch', `v3/ruteo/excepciones/${idException}`, {
    data: { ...data }
  })
)

export const removeExceptionService = (idException) => (
  service('delete', `v3/ruteo/excepciones/${idException}`)
)
